import { render, staticRenderFns } from "./login-with-pwd.vue?vue&type=template&id=faf1d904&scoped=true&"
import script from "./login-with-pwd.vue?vue&type=script&lang=ts&"
export * from "./login-with-pwd.vue?vue&type=script&lang=ts&"
import style0 from "./login-with-pwd.vue?vue&type=style&index=0&id=faf1d904&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf1d904",
  null
  
)

export default component.exports